// SAV-550: Word dokumentai atsineša savo <style> bloką. Jo taisyklės
// (pvz. `h1 { text-decoration: line-through }`) taikomos VISAM puslapiui,
// ne tik dokumentui — todėl perrašo svetainės pavadinimą, mygtukus, nuorodas.
//
// Čia kiekvienam selektoriui priekyje pridedamas dokumento konteineris, todėl
// taisyklė gali paveikti tik dokumento vidų. Vykdoma naršyklėje atvaizdavimo
// metu — niekas nesaugoma DB.
//
// Word'o <!-- --> apvalkalas ir @page (kuriuos anksčiau čia buvo bandoma
// specialiai apdoroti) realioje naršyklėje pasirodė nekeliantys jokios
// rizikos savaime — Chrome juos korektiškai apdoroja arba tiesiog atmeta
// bandymą juos perrašyti. Todėl čia nebeliečiami.

function splitSelector(selectorText) {
  // Skaidome per "," bet IGNORUOJAME kablelius skliaustų viduje — priešingu
  // atveju ":is(h1, p)" būtų sugadintas, nes tas kablelis nėra atskirų
  // selektorių skirtukas, o pačios :is()/:not() funkcijos vidinio sąrašo dalis.
  const parts = [];
  let depth = 0;
  let current = '';
  for (const char of selectorText) {
    if (char === '(') depth++;
    if (char === ')') depth--;
    if (char === ',' && depth === 0) {
      parts.push(current);
      current = '';
    } else {
      current += char;
    }
  }
  parts.push(current);
  return parts;
}

function scopeSelector(sel, scope) {
  // Nuimame priekyje esantį html/body (gali kartotis, pvz. "html body p"),
  // kad tokios taisyklės būtų pritaikytos pačiam konteineriui.
  const s = sel.trim().replace(/^(?:(?:html|body)\b\s*)+/i, '').trim();
  return s ? `${scope} ${s}` : scope;
}

function scopeCss(cssText, scope) {
  // CSS analizuoja pati naršyklė (ne regex) — tik taip teisingai suveikia
  // sugrupuoti selektoriai, @media ir kitos konstrukcijos.
  const doc = document.implementation.createHTMLDocument('');
  const style = doc.createElement('style');
  style.textContent = cssText;
  doc.head.appendChild(style); // .sheet užsipildo tik įdėjus į dokumentą
  if (!style.sheet) return cssText;

  const walk = (rule) => {
    if (rule.cssRules && rule.cssRules.length) {
      // @media, @supports — apribojame VIDUJE esančias taisykles, apvalkalą paliekame
      return Array.from(rule.cssRules).forEach(walk);
    }
    if (!rule.selectorText) return; // @font-face/@keyframes — nėra ką keisti
    rule.selectorText = splitSelector(rule.selectorText)
      .map((s) => scopeSelector(s, scope))
      .join(',');
  };

  Array.from(style.sheet.cssRules).forEach(walk);

  return Array.from(style.sheet.cssRules).map((r) => r.cssText).join('\n');
}

export function scopeDocumentStyles(html, scope) {
  if (!html || html.indexOf('<style') === -1) return html; // nėra ko keisti

  return html.replace(/<style\b[^>]*>([\s\S]*?)<\/style>/gi, (match, css) => {
    return `<style>${scopeCss(css, scope)}</style>`;
  });
}
